var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4387_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.341 6.6354C43.4624 5.75667 42.0379 5.75667 41.159 6.6354L14.2026 33.5921L3.84104 23.2305C2.9624 22.3517 1.53787 22.3518 0.659048 23.2305C-0.219683 24.1091 -0.219683 25.5336 0.659048 26.4124L12.6116 38.3648C13.49 39.2434 14.9156 39.2428 15.7936 38.3648L44.341 9.81739C45.2198 8.93875 45.2197 7.51413 44.341 6.6354Z",
    fill: "#3DCBB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4387_578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneTick);
export default __webpack_public_path__ + "static/media/done-tick.d7ddc8c9916d90c604d06210d00c705a.svg";
export { ForwardRef as ReactComponent };